export default __webpack_public_path__ + "static/media/premium-the-strip-district.57231cbc.png";